import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";
export default class extends ApplicationController {
  static targets = ["hm0_output"];
  connect() {
    super.connect();
    var self = this;

   }
  get current_app() {
    return this.data.get("app");
  }
  get conge_id() {
    return this.data.get("congeid");
  }
  get url_solution() {
    return this.data.get("urlsolution");
  }
}
